import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

console.log('当前浏览器语言：' + navigator.languages[1])

Vue.use(VueI18n)

const messages = {
  zh,
  en,
}

const i18n = new VueI18n({
  locale: navigator.languages[1] || 'en',
  fallbackLocale: 'en',
  messages,
})

export default i18n
